export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7d-9d3be65d7a0c68844dfc41ab1634db73.webp";